import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AgNotesModelParams } from '@shared/ag-components/ag-notes/ag-notes.model';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective],
  standalone: true,
  styleUrls: ['ag-notes.component.scss'],
  templateUrl: 'ag-notes.component.html',
})
export class AgNotesComponent implements ICellRendererAngularComp {
  params!: AgNotesModelParams;

  agInit(params: AgNotesModelParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
